
import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ExceptionService, Searcher, UtilsService } from '../../xform-compat';
import { Role, SearchResult, User } from '../../shared/models';
import { CONFIG } from '../../config';
import { SearchParams } from '../../shared/models/search-portal/search-params';
import { Observable } from 'rxjs/internal/Observable';


@Injectable({
  providedIn: 'root'
})
export class SearchService implements Searcher {
  private apiPath = `${CONFIG.apiUrl}/search`;
  private apiSearchPortal = `${CONFIG.apiUrl}/rms/searchportal`;

  private searchableTypes = {
    'User': User,
    'Role': Role
  };

  constructor(
    private http: HttpClient,
    private exceptionService: ExceptionService,
    private utilsService: UtilsService
  ) {}

  /**
   * Gets the records for quick search
   * @param params
   */
  public getRecords(params?: object) {
    const httpParams = this.utilsService.generateParams(params);
    return this.http.get<Array<SearchResult>>(this.apiPath, { params: httpParams }).pipe(
      catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

  /**
   * Returns the display name
   * @param item
   */
  public getDisplayName(item: SearchResult): string {
    const typeClass: any = this.searchableTypes[item.type];
    const body = new typeClass(item.body);
    return body.getDisplayName();
  }

  /**
   * Gets the records for companies
   * @param obj
   */
  public getSearchCompanies(obj: any) {
    const httpParams = this.utilsService.generateParams(obj.defaultParams);
    return this.http.get<Array<SearchResult>>(`${this.apiSearchPortal}/company/${obj.searchTerm}`, { params: httpParams }).pipe(
      catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

  /**
   * Gets the records for insights
   * @param obj
   */
  public getSearchInsights(obj: any) {
    const httpParams = this.utilsService.generateParams(obj.defaultParams);
    return this.http.get<Array<SearchResult>>(`${this.apiSearchPortal}/insight/${obj.searchTerm}`, { params: httpParams }).pipe(
      catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

  /**
   * Gets the records for compannies notes
   * @param obj
   */
  public getSearchCompaniesNotes(obj: any) {
    const httpParams = this.utilsService.generateParams(obj.defaultParams);
    return this.http.get<Array<SearchResult>>(`${this.apiSearchPortal}/company_note/${obj.searchTerm}`, { params: httpParams }).pipe(
      catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

  /**
   * Gets the records for products
   * @param obj
   */
  public getSearchProducts(obj: any) {
    const httpParams = this.utilsService.generateParams(obj.defaultParams);
    return this.http.get<Array<SearchResult>>(`${this.apiSearchPortal}/product/${obj.searchTerm}`, { params: httpParams }).pipe(
      catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

  /**
   * Gets the records for indications
   * @param obj
   */
  public getSearchIndications(obj: any) {
    const httpParams = this.utilsService.generateParams(obj.defaultParams);
    return this.http.get<Array<SearchResult>>(`${this.apiSearchPortal}/indication/${obj.searchTerm}`, { params: httpParams }).pipe(
      catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

  /**
   * Gets the records for indications notes
   * @param obj
   */
  public getSearchIndicationsNotes(obj: any) {
    const httpParams = this.utilsService.generateParams(obj.defaultParams);
    return this.http.get<Array<SearchResult>>(`${this.apiSearchPortal}/indication_note/${obj.searchTerm}`, { params: httpParams }).pipe(
      catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

  public getSearchNotesWithFilters(obj: any) {
    if (!('query' in obj) || !obj.query || obj.query.length === 0) {
 return;
}
    const httpParams = this.utilsService.generateParams(obj);
    return this.http.get<Array<SearchResult>>(`${this.apiSearchPortal}/${obj.entity}`, { params: httpParams }).pipe(
      catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

  /**
   * Gets the records for attachments
   * @param obj
   */
  public getSearchAttachments(obj: SearchParams): Observable<any> {
    const httpParams = this.utilsService.generateParams(obj.defaultParams);
    return this.http.get<Array<SearchResult>>(`${this.apiSearchPortal}/attachment/${obj.searchTerm}`, { params: httpParams }).pipe(
      catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }
}
